/**
 * ยอดเขาหิมะ, the Snow Peak: cold and sparse. Qin harmonics like falling flakes, long silences, a
 * thin xiao, wind, little bells. In 角 mode, the most austere of the five.
 */
import { drone } from '../compose';
import { registerTrack } from '../registry';

const A_QIN = `@mp 3'* 0 2'* 0 | 1'*- 6* 0 | 5* 0 6* 1'* | 3'*--- |
  0- 6* 5* | 3*- 2* 0 | 1* 2* 3* 5* | 3*---`;
const A_XIAO = `@p 0--- | 0--- | 0--- | 0- 3- | 5- 6- | 3--- ; | 2_ 1_ 6,- 1 | 3---`;

const B_QIN = `@mf 3,/- 5,- | 6,~- 5,\\- | 3,_ 2,_ 1,- 2, | 3,~--- |
  6,/- 1- | 2_ 1_ 6,- 5, | 3,- 2,_ 1,_ 2, | 3,,~---`;
const B_XIAO = `@pp 3--- | 0--- | 5--- | 0--- | 6--- | 0--- | 5- 3- | 3---`;

const AIR = `h--- | 0--- | w--- | 0--- | 0--- | h--- | w--- | 0---`;

registerTrack({
  id: 'snow',
  order: 12,
  title: 'หิมะโปรยบนยอดเขา',
  mood: 'หนาวเหน็บ โดดเดี่ยว เบาบาง',
  use: 'ยอดเขาหิมะ ทั้งกลางวันและกลางคืน',
  key: 'D',
  mode: 'jue',
  bpm: 50,
  meter: 4,
  seed: 1212,
  humanize: 0.6,
  parts: {
    qin: { inst: 'qin', pan: 0.1, reverb: 0.65 },
    xiao: { inst: 'xiao', gain: 0.75, pan: -0.25, reverb: 0.65 },
    pad: { inst: 'pad', gain: 0.45, reverb: 0.6 },
    air: { inst: 'perc', gain: 0.14, pan: 0.3, reverb: 0.7 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { qin: A_QIN, xiao: A_XIAO, pad: drone(`3, 3, 3, 3, 3, 3, 3, 3,`, 4), air: AIR },
    },
    B: {
      bars: 8,
      parts: { qin: B_QIN, xiao: B_XIAO, pad: drone(`3, 6,, 3, 3, 6,, 2, 3, 3,`, 4), air: AIR },
    },
  },
  form: ['A', 'B', 'A'],
  loop: true,
});
